module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_30_1-518254feffa0b2dbd35581083822efb7.svg";